<template>
  <footer class="flex v-center">
    <span>{{ organization }}</span>
    <!-- <div id="captchaValidacao"></div> -->
    <span>Versão {{ version }}</span>
  </footer>
</template>

<script>
import pkg from 'package.json';

export default {
	data() {
		return {
			organization: pkg.organization,
			version: pkg.version,
		};
	},

  // async mounted() {
  //   await this.initMCaptcha();
  // },

  // methods: {
  //   initMCaptcha() {

  //     // Verifica se o script já foi carregado para não duplicar
  //     if (!document.getElementById("mcaptcha-script")) {
  //       const script = document.createElement("script");
  //       script.id = "mcaptcha-script";
  //       // endereço do widget do captcha
  //       script.src = "https://unpkg.com/@mcaptcha/vanilla-glue@0.1.0-rc2/dist/index.js";
  //       script.async = true;

  //       // O vanilla-glue executa automaticamente ao carregar.
  //       document.head.appendChild(script);
  //     }
  //   },
  // },
};
</script>

<style scoped>
footer {
  justify-content: space-between;
  min-height: 50px;
  max-height: 50px;
}

#captchaValidacao {
  transform: scale(0.5);
  opacity: 0.5;
  transition: all 0.5s ease-in-out;
}

#captchaValidacao:hover {
  transform: scale(1);
  opacity: 1;
  margin-bottom: 28px;
}

/* não cabe o captcha em celular */
@media (max-width: 600px) {
  #captchaValidacao {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// application/views/commons/footer.vue?e3864ca4